var locale = {
  'login.bell.title': 'Notice',
  'login.account.title': 'Account',
  'login.account.user.id': 'User ID',
  'login.account.user.info': 'Personal Information',
  logout: 'Log out',
  login: 'Login'
};
export default locale;